import { render, staticRenderFns } from "./AppRelacionamento.vue?vue&type=template&id=56c64a9c"
import script from "./AppRelacionamento.vue?vue&type=script&lang=js"
export * from "./AppRelacionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports